export default __webpack_public_path__ + "static/media/how-to-rotate-an-image.af0be12a.png";